// Real logos for the bridged assets in domain/tokens.ts CURATED_TOKENS —
// sourced from Trust Wallet's public asset repo, keyed by each bridged
// token's real-world counterpart on its origin chain (BNB Smart Chain),
// verified live (200, image/png) before adding. Other local/test tokens
// (MHK, STT1, …) have no real-world logo and are deliberately left out —
// they keep the generated colored-circle fallback in TokenAvatar.
const TRUST_WALLET_SMARTCHAIN = "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/smartchain/assets";

const TOKEN_LOGOS: Record<string, string> = {
  // DotOneSwap's own native wrapped token — the app's own logo, not a
  // Trust Wallet asset.
  WDOTO: "/doto.svg",
  WBNB: `${TRUST_WALLET_SMARTCHAIN}/0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c/logo.png`,
  WETH: `${TRUST_WALLET_SMARTCHAIN}/0x2170Ed0880ac9A755fd29B2688956BD959F933F8/logo.png`,
  WUSDT: `${TRUST_WALLET_SMARTCHAIN}/0x55d398326f99059fF775485246999027B3197955/logo.png`,
  WUSDC: `${TRUST_WALLET_SMARTCHAIN}/0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d/logo.png`,
  WBTCB: `${TRUST_WALLET_SMARTCHAIN}/0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c/logo.png`,
  WDAI: `${TRUST_WALLET_SMARTCHAIN}/0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3/logo.png`,
  WLINK: `${TRUST_WALLET_SMARTCHAIN}/0xF8A0BF9cF54Bb92F17374d9e9A321E6a111a51bD/logo.png`,
  WCake: `${TRUST_WALLET_SMARTCHAIN}/0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82/logo.png`,
  WSHIB: `${TRUST_WALLET_SMARTCHAIN}/0x2859e4544C4bB03966803b044A93563Bd2D0DD4D/logo.png`,

  // Plain-symbol entries for the BSC swap panel (domain/bscTokens.ts) — same
  // real BEP-20 assets as their bridged "W"-prefixed counterparts above, so
  // reusing the same Trust Wallet logo URLs.
  BNB: `${TRUST_WALLET_SMARTCHAIN}/0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c/logo.png`,
  USDT: `${TRUST_WALLET_SMARTCHAIN}/0x55d398326f99059fF775485246999027B3197955/logo.png`,
  USDC: `${TRUST_WALLET_SMARTCHAIN}/0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d/logo.png`,
  BUSD: `${TRUST_WALLET_SMARTCHAIN}/0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56/logo.png`,
  ETH: `${TRUST_WALLET_SMARTCHAIN}/0x2170Ed0880ac9A755fd29B2688956BD959F933F8/logo.png`,
  BTCB: `${TRUST_WALLET_SMARTCHAIN}/0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c/logo.png`,
  CAKE: `${TRUST_WALLET_SMARTCHAIN}/0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82/logo.png`,
  DAI: `${TRUST_WALLET_SMARTCHAIN}/0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3/logo.png`,
  LINK: `${TRUST_WALLET_SMARTCHAIN}/0xF8A0BF9cF54Bb92F17374d9e9A321E6a111a51bD/logo.png`,
  SHIB: `${TRUST_WALLET_SMARTCHAIN}/0x2859e4544C4bB03966803b044A93563Bd2D0DD4D/logo.png`,
  DOGE: `${TRUST_WALLET_SMARTCHAIN}/0xbA2aE424d960c26247Dd6c32edC70B295c744C43/logo.png`,
  XRP: `${TRUST_WALLET_SMARTCHAIN}/0x1D2F0da169ceB9fC7B3144628dB156f3F6c60dBE/logo.png`,
  ADA: `${TRUST_WALLET_SMARTCHAIN}/0x3EE2200Efb3400fAbB9AacF31297cBdD1d435D47/logo.png`,
  DOT: `${TRUST_WALLET_SMARTCHAIN}/0x7083609fCE4d1d8Dc0C979AAb8c869Ea2C873402/logo.png`,
  MATIC: `${TRUST_WALLET_SMARTCHAIN}/0xCC42724C6683B7E57334c4E856f4c9965ED682bD/logo.png`,
  AVAX: `${TRUST_WALLET_SMARTCHAIN}/0x1CE0c2827e2eF14D5C4f29a091d735A204794041/logo.png`,
  UNI: `${TRUST_WALLET_SMARTCHAIN}/0xBf5140A22578168FD562DCcF235E5D43A02ce9B1/logo.png`,
  LTC: `${TRUST_WALLET_SMARTCHAIN}/0x4338665CBB7B2485A8855A139b75D5e34AB0DB94/logo.png`,
  // No entry for TRX — this token's address has no logo in Trust Wallet's
  // repo (verified live: 404), so it keeps TokenAvatar's generated fallback.
  FDUSD: `${TRUST_WALLET_SMARTCHAIN}/0xc5f0f7b66764F6ec8C8Dff7BA683102295E16409/logo.png`,

  // Network icons for the LI.FI multi-chain switcher (config/networks.ts's
  // nativeSymbol) — verified live (200, image/png) before adding. POL is
  // Polygon's own chain logo (its native currency, post-MATIC rebrand); ARB
  // is the Arbitrum governance token's own logo, used here purely as a
  // distinct per-network icon (see the comment on that network's config).
  POL: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/polygon/info/logo.png",
  ARB: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/arbitrum/assets/0x912CE59144191C1204E64559FE8253a0e49E6548/logo.png",
};

export function resolveTokenLogo(symbol: string | undefined): string | undefined {
  if (!symbol) return undefined;
  return TOKEN_LOGOS[symbol];
}
